import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// Internal imports - api
import { useAdminContext } from '../../../../api/AdminContext';
import useQuestionBankContext from '../../../../api/QuestionBankContext';
// Internal imports - components
import Badge from '../../../../components/ui/Badge';
import QuestionsManagerContainer from '../QuestionsManagerContainer';
import ViewEditAudioExplanation from './components/VieEditAudioExplanation';
import ViewEditAnswer from './components/ViewEditAnswer';
import ViewEditCategory from './components/ViewEditCategory';
import ViewEditExplanation from './components/ViewEditExplanation';
import ViewEditFuente from './components/ViewEditFuente';
import ViewEditImage from './components/ViewEditImage';
import ViewEditImageDisplay from './components/ViewEditImageDisplay';
import ViewEditIssues from './components/ViewEditIssues';
import ViewEditQuestion from './components/ViewEditQuestion';
import ViewEditSubCategoryList from './components/ViewEditSubCategoryList';
import ViewEditTags from './components/ViewEditTags';
import ViewEditTestLabel from './components/ViewEditTestLabel';
// Internal imports - types
import type { Category, Question } from '../../../../data/interface-question';
import type { QuestionBankID } from '../../../../data/interface-question-bank';

const QuestionEditor = () => {
	const {
		// questions,
		adminQuestions,
		updateQuestionbyKey
	} = useAdminContext();
	const { categories } = useQuestionBankContext();
	const [questionObj, setQuestionObj] = useState<Question>();
	const params = useParams();
	const questionId = params.id;
	const questionBankID = localStorage.getItem(
		'questionBankID'
	) as QuestionBankID;

	useEffect(() => {
		if (questionId !== undefined) {
			const questionFound = adminQuestions?.find((q) => q.id === questionId);
			if (questionFound !== undefined) {
				setQuestionObj(questionFound);
			}
		}
	}, [adminQuestions]);

	const handleUpdate = async (
		questionID: string,
		key: string,
		newValue: any
	): Promise<Question | null> => {
		try {
			await updateQuestionbyKey(questionID, key, newValue);
			if (questionObj === undefined || questionObj.id !== questionID) {
				return null;
			}
			const updatedQuestion: Question = { ...questionObj, [key]: newValue };
			setQuestionObj(updatedQuestion);
			return updatedQuestion;
		} catch (error) {
			console.error('Failed to update question:', error);
			return null;
		}
	};

	if (questionObj === undefined) return null;
	return (
		<QuestionsManagerContainer title='Question Editor' bgColor='bg-brand-25'>
			{/* <div className='bg-red-400 text-white rounded py-4 px-2'>
				THIS IS NOT FINISHED AND MAY CAUSE ISSUES. PLEASE DO NOT USE IT.
			</div> */}
			<div className='mt-4'>
				<div className='my-2'>
					<Badge
						title={`QuestionID: ${questionObj.id}`}
						textColor='text-orange-500'
						ringColor='ring-orange-500/30'
					/>
				</div>
				<ViewEditTestLabel question={questionObj} onUpdate={handleUpdate} />
				<ViewEditCategory
					categories={categories as Category[]}
					question={questionObj}
					questionBankID={questionBankID}
					onUpdate={handleUpdate}
				/>
				<ViewEditSubCategoryList
					categories={categories as Category[]}
					question={questionObj}
					questionBankID={questionBankID}
					onUpdate={handleUpdate}
				/>
				<ViewEditQuestion question={questionObj} onUpdate={handleUpdate} />
				<ViewEditAnswer
					question={questionObj}
					option='answer'
					onUpdate={handleUpdate}
				/>
				<ViewEditAnswer
					question={questionObj}
					option='option1'
					onUpdate={handleUpdate}
				/>
				<ViewEditAnswer
					question={questionObj}
					option='option2'
					onUpdate={handleUpdate}
				/>
				<ViewEditAnswer
					question={questionObj}
					option='option3'
					onUpdate={handleUpdate}
				/>
				<ViewEditAudioExplanation
					question={questionObj}
					onUpdate={handleUpdate}
				/>
				<ViewEditExplanation question={questionObj} onUpdate={handleUpdate} />
				<ViewEditFuente question={questionObj} onUpdate={handleUpdate} />
				<ViewEditImage question={questionObj} onUpdate={handleUpdate} />
				<ViewEditImageDisplay question={questionObj} onUpdate={handleUpdate} />
				<ViewEditTags
					categories={categories ?? []}
					question={questionObj}
					questionBankID={questionBankID}
					onUpdate={handleUpdate}
				/>
				<ViewEditIssues question={questionObj} onUpdate={handleUpdate} />
			</div>
		</QuestionsManagerContainer>
	);
};
export default QuestionEditor;
